import Vue from 'vue'
import { patientStatesConfigs } from '@/scripts/configs/patient-state-configs'

const generatePatientListDefaultState = () => {
  const defaultState = {
    list: {},
    listAll: [],
    fetching: {},
    fetchingAll: null,
    counters: { states: {} },
    cellDetailsByPatientId: {},
    search: {
      value: '',
      type: 'firstname',
    },
  }

  patientStatesConfigs.forEach((ps) => {
    defaultState.list[ps.key] = [] // One list for each patient state
    defaultState.fetching[ps.key] = {
      isFetching: null,
      completed: false,
    }
    defaultState.counters.states[ps.key] = 0
  })

  return defaultState
}

export default {
  namespaced: true,
  state: generatePatientListDefaultState(),
  getters: {
    getAllPatientsList: (state) => state.listAll,
  },
  mutations: {
    setAsFetching(state, payload) {
      Object.keys(payload).forEach((prop) => {
        state.fetching[prop].isFetching = payload[prop]
      })
    },
    setFetchingAll(state, fetchingStatus) {
      state.fetchingAll = fetchingStatus
    },
    setAsCompleted(state, payload) {
      Object.keys(payload).forEach((prop) => {
        state.fetching[prop].completed = payload[prop]
      })
    },
    setAllPatientsList(state, patients) {
      state.listAll = patients
    },
    resetAllPatientsList(state) {
      state.listAll = []
    },
  },
  actions: {
    async fetchAllPatients({ commit }, { institutionId, search }) {
      try {
        commit('setFetchingAll', true)
        const { data: fetchedPatientsList } = await Vue.$http('patientsList/fetchAllPatients', { institutionId, search })

        commit('setAllPatientsList', fetchedPatientsList)
      } catch (e) {
        console.error('Error fetching patient list.', e)
      } finally {
        commit('setFetchingAll', false)
      }
    },
    resetAllPatientsList({ commit }) {
      commit('resetAllPatientsList')
    },
  },
}
